<template>
  <div v-if="object && dataReady" style="width: 99%">
    <div class="row text-black-50" style="background: #e6ab8e">
      <div class="col-md-11" style="text-align: left">
        <i class="tim-icons icon-simple-remove" v-on:click="toView" style="margin-right: 10px"></i>
        <b>Новый документ</b>
      </div>
      <div class="col-md-1" style="text-align: right">
        <i v-if="!inSave" class="tim-icons icon-check-2" v-on:click="save" style="margin-right: 10px"></i>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <base-input label="Название документа"
                    v-model="object.name">
        </base-input>
      </div>
    </div>
    <div v-if="object.id === 0" class="row">
      <div class="col-md-4">
        <list-option :label="'Документ относится к'" :object="object" :field="'owner'"
                     :name="'name'" :objects="types" :value="'value'">
        </list-option>
      </div>
      <div class="col-md-8"></div>
    </div>

  </div>
</template>
<script>

 import SimpleRow from "@/components/SimpleRow";
 import BaseInput from "@/components/Inputs/BaseInput";
 import BaseCheckbox from "@/components/BaseCheckbox";
 import {longAsStringDate} from "@/services/utils";
 import {authHeader} from "@/services/auth-header";
 import {userService} from "@/services/user.service";

 export default {
   components: {
     SimpleRow,
     BaseInput,
     BaseCheckbox
   },
   props:{
     item: {},
     index: null,
     type: null
   },
   data() {
     return {
       socket: null,
       object: null,
       inSave: false,
       dataReady: false,
       types: []
     }
   },
   methods: {
     convertDate(time) {
       return time ? longAsStringDate(time) : "-";
     },
     fieldView(data) {
       return data ? data : '-';
     },
     toView() {
       this.$emit('toView');
     },
     async save() {
       if (this.object.name && this.object.name.length > 5 && this.object.owner) {
         this.inSave = true;
         try {
           let renewed = await this.$repo.save(this.object, this.type);
           if (renewed) {
             this.item.object = renewed;
             this.item.id = renewed.id;
             this.object = JSON.parse(JSON.stringify(renewed));
             this.inSave = false;
             this.toView();
           }
         } catch(error) {
           this.inSave = false;
         }
       }
     }
   },
   async mounted() {
     this.object = JSON.parse((JSON.stringify(this.item.object)));
     this.types = await this.$repo.getSelector("entities_types");
     this.types = this.types.filter(type => type.value !== 'all');
     this.dataReady = true;
   }
 }
</script>
